import "./App.css";

import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Kyiv" />
        <footer>
          This projected was coded by Julia Pysmenna and is{" "}
          <a
            href="https://github.com/julia-pysmenna/weather-react"
            target="_blank"
            rel=" noopener noreferrer"
          >
            open-sourced on GitHub
          </a>
        </footer>
      </div>
    </div>
  );
}
